<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="acvatcode_keyno" [ttModel]="edit.acvatcode_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="acvatcode_name" [(ttModel)]="edit.acvatcode_name"></tt-input>
        <tt-input ttLabel="amountformula" [(ttModel)]="edit.amountformula" ttRequired></tt-input>
        <tt-button-save ttText="acvatcode_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="acvatcode_keyno" tt-model="vm.model.edit.acvatcode_keyno" tt-change="vm.model.edit.acvatcode_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="acvatcode_name" tt-model="vm.model.edit.acvatcode_name" tt-change="vm.model.edit.acvatcode_name = $value" tt-readonly="false"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="amountformula" tt-model="vm.model.edit.amountformula" tt-change="vm.model.edit.amountformula = $value" tt-readonly="false" tt-required="true"></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="acvatcode_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
